import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Ejecutivo } from 'src/app/global/interfaces/ejecutivo';
import { SessionService } from 'src/app/global/services/session.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {

    @Input() carroOnExito: boolean;
    @Output() accionBtn: EventEmitter<any> = new EventEmitter();
    @Input() displayCartOnMobile: boolean;
    retoma: boolean;
    ejecutivo: Ejecutivo;

    constructor(
        private carroService: CarroComprasService,
        private productServ: vmProductosService,
        public sessionService: SessionService,
        private route: ActivatedRoute) {

    }

    ngOnInit() {
        this.carroService.retoma$.subscribe(resp => {
            this.retoma = resp;
        });

    }

    async ngAfterViewInit(): Promise<void> {
        if (this.displayCartOnMobile) {
            let click_event = new CustomEvent('click');
            let btn_element = document.querySelector('.circulo-notificaciones');
            await new Promise(f => setTimeout(() => { btn_element.dispatchEvent(click_event); }, 1500));
        }
        this.getEjecutivo();
    }

    getEjecutivo() {
        this.ejecutivo = this.sessionService.ejecutivo != null ? this.sessionService.ejecutivo : this.sessionService.getEjecutivo();
    }

    get productos$() {
        return this.carroService.products$;
    }

    get mostrarCarro$(): Observable<boolean> {
        return this.carroService.mostrarCarro$;
    }

    toggleCarro() {
        this.carroService.toogle();
        this.accionBtn.emit(this.carroOnExito);
    }

}
